/* SHOQ THEME 1.0 scripts. No dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- day / night ---------- */
  function setMode(m) {
    document.documentElement.setAttribute('data-theme', m);
    try { localStorage.setItem('shoq-theme', m); } catch (e) {}
    $$('.sq-mode').forEach(function (b) { b.setAttribute('aria-pressed', m === 'light'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sq-mode');
    if (!b) return;
    setMode(document.documentElement.getAttribute('data-theme') === 'light' ? 'dark' : 'light');
  });

  /* ---------- rotating announcements ---------- */
  function initAnnounce(root) {
    $$('.sq-announce', root).forEach(function (a) {
      if (a.dataset.ready) return; a.dataset.ready = 1;
      var s = $$('.sq-msg-item', a); if (s.length < 2) return;
      var k = 0, speed = parseInt(a.dataset.speed || '4', 10) * 1000;
      setInterval(function () { s[k].classList.remove('on'); k = (k + 1) % s.length; s[k].classList.add('on'); }, speed);
    });
  }

  /* ---------- mobile menu / search ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-close-details]');
    if (c) { var d = c.closest('details'); if (d) d.removeAttribute('open'); }
  });

  /* ---------- slideshow ---------- */
  function initSlides(root) {
    $$('.sq-slides', root).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var track = $('.sq-slide-track', el), dots = $$('.sq-slide-dots button', el), n = $$('.sq-slide', el).length, i = 0, t;
      if (n < 2) return;
      function go(k) { i = (k + n) % n; track.style.transform = 'translateX(' + (-100 * i) + '%)'; dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i); }); }
      el.addEventListener('mouseenter', function () { clearInterval(t); }); el.addEventListener('mouseleave', function () { auto(); });
      function auto() { clearInterval(t); var s = parseInt(el.dataset.autoplay || '0', 10); if (s) t = setInterval(function () { go(i + 1); }, s * 1000); }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); auto(); }); });
      $$('[data-slide]', el).forEach(function (b) { b.addEventListener('click', function () { go(i + (b.dataset.slide === 'next' ? 1 : -1)); auto(); }); });
      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); auto(); } x0 = null; });
      auto();
    });
  }

  /* ---------- product carousels ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll]');
    if (!b) return;
    var c = document.getElementById(b.getAttribute('aria-controls'));
    if (c) c.scrollBy({ left: (b.dataset.scroll === 'next' ? 1 : -1) * c.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- before / after ---------- */
  document.addEventListener('input', function (e) {
    if (e.target.matches('.sq-compare input')) e.target.closest('.sq-compare').style.setProperty('--pos', e.target.value + '%');
  });

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    $$('.sq-timer[data-end]', root).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      var end = new Date(el.dataset.end).getTime(); if (isNaN(end)) return;
      var box = el.closest('.sq-countdown');
      function tick() {
        var d = Math.max(0, end - Date.now());
        if (d <= 0 && box && box.dataset.hideEnded === 'true') { box.hidden = true; return; }
        var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
        $$('b', el).forEach(function (b, j) { b.textContent = String(v[j]).padStart(2, '0'); });
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- video (load on click) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sq-play');
    if (!b) return;
    var wrap = b.closest('.sq-ph'), src = b.dataset.src;
    if (!src) return;
    var f = document.createElement('iframe');
    f.src = src; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = b.getAttribute('aria-label') || 'Video';
    wrap.appendChild(f); b.remove();
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sq-qty button');
    if (!b) return;
    var input = $('input', b.closest('.sq-qty'));
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (b.dataset.step === 'up' ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-autosubmit]');
    if (f && !e.target.closest('[data-no-autosubmit]')) f.requestSubmit ? f.requestSubmit() : f.submit();
  });

  /* ---------- product page ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var parts = v.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    v = parts.join('.');
    return (fmt || 'Rs.{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function initProduct(root) {
    $$('[data-sq-product]', root).forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = 1;
      var dataEl = $('script[data-variants]', pdp);
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = pdp.dataset.moneyFormat;
      var idInput = $('input[name="id"]', pdp);

      function current() {
        var opts = $$('.sq-option', pdp).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function update() {
        var v = current();
        $$('.sq-option', pdp).forEach(function (fs) { var c = $('input:checked', fs), l = $('legend b', fs); if (c && l) l.textContent = c.value; });
        var btns = $$('[data-buy]', pdp).concat($$('[data-buy]'));
        if (!v) { btns.forEach(function (b) { b.disabled = true; }); return; }
        if (idInput) idInput.value = v.id;
        $$('[data-price]').forEach(function (el) { el.textContent = money(v.price, fmt); });
        $$('[data-compare]').forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : ''; el.hidden = !(v.compare_at_price > v.price); });
        $$('[data-save]').forEach(function (el) {
          var on = v.compare_at_price > v.price;
          el.hidden = !on;
          if (on) el.textContent = (el.dataset.label || 'Save') + ' ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        });
        btns.forEach(function (b) {
          b.disabled = !v.available;
          if (b.dataset.soldout && b.dataset.label) b.textContent = v.available ? b.dataset.label : b.dataset.soldout;
        });
        if (v.featured_media_id) {
          var slide = $('[data-media-id="' + v.featured_media_id + '"]', pdp);
          if (slide) showMedia(slide);
        }
        if (history.replaceState && pdp.dataset.url) history.replaceState(null, '', pdp.dataset.url + '?variant=' + v.id);
      }
      function showMedia(slide) {
        var main = $('.sq-gallery-main', pdp);
        if (main) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        var id = slide.dataset.mediaId;
        $$('.sq-thumbs button', pdp).forEach(function (t) { t.setAttribute('aria-current', t.dataset.target === id); });
      }
      $$('.sq-option input', pdp).forEach(function (i) { i.addEventListener('change', update); });
      $$('.sq-thumbs button', pdp).forEach(function (t) {
        t.addEventListener('click', function () { var s = $('[data-media-id="' + t.dataset.target + '"]', pdp); if (s) showMedia(s); });
      });
      var main = $('.sq-gallery-main', pdp);
      if (main) main.addEventListener('scroll', function () {
        clearTimeout(main._t);
        main._t = setTimeout(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth), s = main.children[i];
          if (s) $$('.sq-thumbs button', pdp).forEach(function (t) { t.setAttribute('aria-current', t.dataset.target === s.dataset.mediaId); });
        }, 80);
      }, { passive: true });

      /* "Order Now" goes straight to checkout */
      var form = $('form[data-product-form]', pdp);
      $$('[data-buy-now]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (!form) return;
          e.preventDefault();
          var r = $('input[name="return_to"]', form);
          if (!r) { r = document.createElement('input'); r.type = 'hidden'; r.name = 'return_to'; form.appendChild(r); }
          r.value = '/checkout';
          form.submit();
        });
      });
      $$('[data-add-cart]').forEach(function (b) {
        if (b.form === form) return;
        b.addEventListener('click', function (e) { if (form) { e.preventDefault(); var r = $('input[name="return_to"]', form); if (r) r.remove(); form.submit(); } });
      });

      /* sticky bar */
      var sticky = $('.sq-sticky'), anchor = $('[data-buy-anchor]', pdp);
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          sticky.classList.toggle('on', show);
          document.body.classList.toggle('sq-has-sticky', show);
        }).observe(anchor);
      }
    });
  }

  /* ---------- product recommendations ---------- */
  function initRecs(root) {
    $$('[data-recs-url]', root).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = 1;
      fetch(el.dataset.recsUrl).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-recs-url]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.closest('.shopify-section') && (el.closest('.shopify-section').hidden = true);
      }).catch(function () {});
    });
  }

  /* ---------- collection filters (mobile toggle) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.sq-filter-toggle');
    if (!b) return;
    var f = document.getElementById(b.getAttribute('aria-controls'));
    if (f) { f.classList.toggle('open'); b.setAttribute('aria-expanded', f.classList.contains('open')); }
  });

  function init(root) { initAnnounce(root); initSlides(root); initCountdown(root); initProduct(root); initRecs(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();



/* ===== Reviews: auto scroll every 3 seconds ===== */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function start() {
    document.querySelectorAll('.sq-revs:not(.sq-revs--grid)').forEach(function (el) {
      if (el.dataset.auto) return;
      el.dataset.auto = '1';
      var paused = false;
      ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { setTimeout(function () { paused = false; }, 1500); }, { passive: true }); });
      setInterval(function () {
        if (paused || document.hidden) return;
        var card = el.querySelector('.sq-rev');
        if (!card) return;
        var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(el).columnGap) || 0);
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 5) el.scrollTo({ left: 0, behavior: 'smooth' });
        else el.scrollBy({ left: step, behavior: 'smooth' });
      }, 3000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();